import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Hide(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.15 3c2.046.012 4.026.609 5.816 1.731l1.439-1.438a.999.999 0 111.414 1.414L5.023 20.503a.997.997 0 01-1.414 0 .999.999 0 010-1.414l1.311-1.312A13.273 13.273 0 012.62 15.23c-.457-.655-.824-1.337-1.18-1.996l-.1-.188c-.66-1.221-.214-2.084.143-2.777.349-.677.731-1.315 1.137-1.9C4.94 5.029 8.503 3.022 12.15 3zm9.3 4.951a16.964 16.964 0 011.439 2.317c.356.693.801 1.556.142 2.776l-.1.189c-.357.659-.724 1.341-1.18 1.997-2.329 3.351-5.904 5.358-9.564 5.367a10.404 10.404 0 01-2.792-.393 1 1 0 01.542-1.925c.744.21 1.5.316 2.25.318 3.001-.008 5.965-1.693 7.921-4.509.392-.563.717-1.166 1.061-1.804l.102-.19c.14-.259.158-.292-.16-.91a14.83 14.83 0 00-1.259-2.029 1.001 1.001 0 011.597-1.204zM12.207 5C9.165 5.017 6.21 6.704 4.26 9.51a14.935 14.935 0 00-1.002 1.674c-.318.618-.3.65-.16.91l.101.19c.345.638.67 1.24 1.061 1.803a11.266 11.266 0 002.08 2.27l1.96-1.96a4.675 4.675 0 016.48-6.48l1.727-1.728c-1.365-.772-2.835-1.18-4.3-1.19zm-.023 4.13a2.673 2.673 0 00-2.42 3.802l3.552-3.552a2.662 2.662 0 00-1.132-.25z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoHide = React.memo(Hide);
export default MemoHide;